import React from 'react';
import { CheckCircle2, XCircle, AlertCircle } from 'lucide-react';

const STATUS_CONFIG: Record<string, { label: string; cls: string; Icon: React.ElementType }> = {
  '4': { label: 'Homologado', cls: 'text-green-600', Icon: CheckCircle2 },
  '5': { label: 'Denegado', cls: 'text-red-600', Icon: XCircle },
  '7': { label: 'Cancelado', cls: 'text-gray-500', Icon: XCircle },
  '8': { label: 'Divergência', cls: 'text-yellow-600', Icon: AlertCircle },
};

export function StatusBadge({ status }: { status: string }) {
  const cfg = STATUS_CONFIG[status] ?? {
    label: status,
    cls: 'text-muted-foreground',
    Icon: AlertCircle,
  };
  const { Icon } = cfg;
  return (
    <span className={`inline-flex items-center gap-1 text-sm font-medium ${cfg.cls}`}>
      <Icon className="h-4 w-4" />
      {cfg.label}
    </span>
  );
}
